import { render } from "./SwitchingEye.vue?vue&type=template&id=381770f1&scoped=true"
import script from "./SwitchingEye.vue?vue&type=script&lang=js"
export * from "./SwitchingEye.vue?vue&type=script&lang=js"

import "./SwitchingEye.vue?vue&type=style&index=0&id=381770f1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381770f1"]])

export default __exports__